/**
 * 全局常量，方法封装模块
 * 通过原型挂载到Vue属性
 * 通过this.global调用
 */
//后台管理系统地址
export const PROD_ENV = true
export const baseUrl = 'http://www.edianzhang.com' //http://www.e-dianzhang.com
export const backupBaseUrl = 'http://localhost:8002'
export const DEFAULT_PAGE_SIZE = 40

/**PROD**/
export const APP_KEY ="21379643"  //PROD
export const APP_REDIRECT_URL ="http://www.edianzhang.com/login/doToken" 
export const TAOBAO_OAUTH_URL =  
"https://oauth.taobao.com/authorize?response_type=code&client_id="+
APP_KEY+
"&redirect_uri="+APP_REDIRECT_URL+"&state=1212&view=web" //"https://oauth.tbsandbox.com/token?response_type=code&client_id="+APP_KEY+"&redirect_uri="+APP_REDIRECT_URL+"&state=1212&view=web"

export const TAOBAO_FUWU_APP_URL ="https://fuwu.taobao.com/ser/detail.htm?service_code=FW_GOODS-1859823"

export const TAOBAO_ITEM_EDIT_URL = "https://item.upload.taobao.com/sell/publish.htm?itemId="

export const APP_FUWU_ORDER_URL = "https://fuwu.taobao.com/ser/detail.htm?service_code=FW_GOODS-1859823"

export const TAOBAO_ORDER_DETAILED_URL = "https://trade.taobao.com/trade/detail/trade_order_detail.htm?biz_order_id="


export const KEYS = {
  TAOBAO_ITEM_STATUS_ONSALE:"onsale",
  TAOBAO_ITEM_STATUS_ONSALE_DESC:"在售中",
  TAOBAO_ITEM_STATUS_INSTORE:"instock",
  TAOBAO_ITEM_STATUS_INSTORE_DESC:"已下架",
  STATUS_ACTIVE :"ACTIVE",//ACT 正常生效
  STATUS_INACTIVE :"INACTIVE", //INACT 失效
  STATUS_DELECTED :"DELETED",//DEL 彻底删除标识
  STATUS_STOP :"STOP",//STP
  STATUS_EXPIRED :"EXPIRED",//EXP
  STATUS_NEW :"NEW",//NEW
  STATUS_INIT :"INIT", //INT
}

export default {
  PROD_ENV, baseUrl, backupBaseUrl,DEFAULT_PAGE_SIZE, APP_KEY,TAOBAO_OAUTH_URL,TAOBAO_FUWU_APP_URL,KEYS,
  TAOBAO_ITEM_EDIT_URL,
  APP_FUWU_ORDER_URL,
  TAOBAO_ORDER_DETAILED_URL
}


// WEBPACK FOOTER //
// ./src/utils/global.js